import MuiContainer, { ContainerProps as MuiContainerProps } from '@mui/material/Container'

export interface ContainerProps extends MuiContainerProps { }

export const Container = (props: MuiContainerProps): JSX.Element => (
  <MuiContainer maxWidth="lg" sx={{ mt: 4, mb: 4 }} {...props} />
)